/*
 * Datazoom, Inc ("COMPANY") CONFIDENTIAL
 * Copyright (c) 2017-2018 [Datazoom, Inc.], All Rights Reserved.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 */

// Action Creator
export const types = {
  DISMISS_NOTIFICATION: "[User Notification] Dismiss Notification",
  CLEAR_DISMISS_NOTIFICATION: "[User Notification] Clear Dismiss Notification",

  RESET_DISMISS_NOTIFICATION: "[User Notification] Reset Dismiss Notification",
  FETCH_PENDING_USER_NOTIF:
    "[Pending User Notification] Fetch Pending User Notification",
  FETCH_PENDING_USER_NOTIF_SUCCESS:
    "[Pending User Notification] Fetch Pending User Notification success",
  FETCH_PENDING_USER_NOTIF_FAILED:
    "[Pending User Notification] Fetch Pending User Notification failed",

  FETCH_TRIAL_PERIOD_NOTIF:
    "[Trial Period Notification] Fetch Trial Period Notification",
  FETCH_TRIAL_PERIOD_NOTIF_SUCCESS:
    "[Trial Period Notification] Fetch Trial Period Notification success",
  FETCH_TRIAL_PERIOD_NOTIF_FAILED:
    "[Trial Period Notification] Fetch Trial Period Notification failed",
};
//
// ─── FETCH PENDING USER NOTIFICATIONS FOR ADMINS──────────────────────────────────────────────────────────────────────
//

export const FetchPendingUserNotif = (companyId, userId) => ({
  type: types.FETCH_PENDING_USER_NOTIF,
  payload: {
    companyId,
    userId,
  },
});
export const FetchPendingUserNotifSuccess = (list) => ({
  type: types.FETCH_PENDING_USER_NOTIF_SUCCESS,
  payload: list,
});
export const FetchPendingUserNotifFailed = (error) => ({
  type: types.FETCH_PENDING_USER_NOTIF_FAILED,
  payload: error,
});
//
// ─── FETCH TRIAL PERIOD NOTIFICATIONS FOR ADMINS──────────────────────────────────────────────────────────────────────
//

export const FetchTrialPeriodNotif = (companyId) => ({
  type: types.FETCH_TRIAL_PERIOD_NOTIF,
  payload: companyId,
});
export const FetchTrialPeriodNotifSuccess = (list) => ({
  type: types.FETCH_TRIAL_PERIOD_NOTIF_SUCCESS,
  payload: list,
});
export const FetchTrialPeriodNotifFailed = (error) => ({
  type: types.FETCH_TRIAL_PERIOD_NOTIF_FAILED,
  payload: error,
});
//
// ─── Dismiss──────────────────────────────────────────────────────────────────────
//

export const DismissNotification = (type) => ({
  type: types.DISMISS_NOTIFICATION,
  payload: type,
});
export const ClearDismissedNotifications = (type) => ({
  type: types.CLEAR_DISMISS_NOTIFICATION,
});
export const ResetDismissNotification = () => ({
  type: types.RESET_DISMISS_NOTIFICATION,
});
